import {
  EmailOutlined,
  PercentOutlined,
  HourglassBottomOutlined,
  SendOutlined,
  ErrorOutlineOutlined,
  ListAltOutlined,
  TranslateOutlined,
  CategoryOutlined,
} from "@mui/icons-material";
import { IEmailStats } from "../interfaces/email-list/IEmailList";

export const getEmailListStatusIcon = (key: keyof IEmailStats) => {
  switch (key) {
    case "name":
      return <EmailOutlined />;
    case "successRate":
      return <PercentOutlined />;
    case "pending":
      return <HourglassBottomOutlined />;
    case "sent":
      return <SendOutlined />;
    case "failed":
      return <ErrorOutlineOutlined />;
    case "total":
      return <ListAltOutlined />;
    case "language":
      return <TranslateOutlined />;
    case "category":
      return <CategoryOutlined />;
    default:
      return <></>;
  }
};
